import type { DefaultDateTimeFormatSchema } from 'vue-i18n'

export const datetimeEn: DefaultDateTimeFormatSchema = {
  default: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  short: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  long: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
}
